module.exports = __webpack_public_path__ + "icons/clock-f228363c94e4236eca9cbd2303f3e3be.svg";


//////////////////
// WEBPACK FOOTER
// ./images/icons/clock.svg
// module id = pSz2
// module chunks = 24